import React from 'react';
import PropTypes from 'prop-types';

const Heart = ({ fill }) => (
  <svg
    width="19px"
    height="17px"
    viewBox="0 0 19 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Saved" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="User-Saved-List-view"
        transform="translate(-331.000000, -516.000000)"
        fill={fill}
      >
        <path
          d="M336.055851,516 C334.754617,516 333.453286,516.50908 332.471723,517.534654 C330.508476,519.585828 330.510375,522.873418 332.471723,524.926414 L339.967004,532.77399 C340.103975,532.918332 340.295174,533 340.49587,533 C340.695618,533 340.886814,532.918332 341.024735,532.77399 C343.525516,530.161616 346.027027,527.546325 348.527565,524.93395 C350.490812,522.882777 350.490812,519.593242 348.527565,517.542191 C346.564318,515.491139 343.322677,515.491017 341.359309,517.542191 L340.499449,518.43102 L339.63959,517.534581 C338.657978,516.508983 337.356744,516 336.055462,516 L336.055851,516 Z M336.025331,517.416667 C336.940028,517.416667 337.860462,517.781139 338.576821,518.507282 L339.971362,519.924336 C340.109283,520.065298 340.30181,520.145054 340.503899,520.145054 C340.705034,520.145054 340.897558,520.065298 341.036436,519.924336 L342.423302,518.514713 C343.855186,517.063353 346.086746,517.063353 347.518679,518.514713 C348.950564,519.966072 348.950564,522.316125 347.518679,523.767413 C345.179749,526.137812 342.838906,528.504459 340.5,530.875 L333.481321,523.760054 C332.049436,522.306842 332.049436,519.958641 333.481321,518.507353 C334.197753,517.78121 335.110512,517.416667 336.025209,517.416667 L336.025331,517.416667 Z"
          id="Fill-1-Copy-3"
        />
      </g>
    </g>
  </svg>
);

Heart.propTypes = {
  fill: PropTypes.string,
};

Heart.defaultProps = {
  fill: 'white',
};

export default Heart;
